export default __webpack_public_path__ + "static/media/local_pizza-24px.9023618f.svg";